import { Box, Layout, theme } from '@/components';
import { useElementOffsetHeight } from '@/hooks';
import { HEADER_ID_FOR_OFFSET_HEIGHT, PAGE_CONTENT_PADDING } from '@/utils';
import type { FC, PropsWithChildren } from 'react';

type Props = {
  withFooter?: boolean;
  footerHeight?: number;
  isGrayBackground?: boolean;
};

const HEADER_SEPARATOR_BORDER = 1;

export const PageContent: FC<PropsWithChildren<Props>> = ({
  children,
  withFooter,
  isGrayBackground,
}) => {
  const { token } = theme.useToken();
  const headerHeight = useElementOffsetHeight({
    targetId: HEADER_ID_FOR_OFFSET_HEIGHT,
  });

  if (withFooter) {
    return (
      <Box
        minHeight={`calc(100svh - ${headerHeight + HEADER_SEPARATOR_BORDER}px)`}
        display="flex"
        flexDirection="column"
      >
        <Layout.Content
          style={{
            flex: 1,
            padding: PAGE_CONTENT_PADDING,
            backgroundColor: isGrayBackground
              ? token.colorBgContainerDisabled
              : 'white',
          }}
        >
          {children}
        </Layout.Content>
      </Box>
    );
  }

  return (
    <Layout.Content style={{ padding: PAGE_CONTENT_PADDING }}>
      {children}
    </Layout.Content>
  );
};
